import React, { Component } from 'react';
import {Link, withRouter} from "react-router-dom";
import AppNavbar from '../AppNavbar.js';
import './legal.css';
import {Cookies, withCookies} from "react-cookie";
import {instanceOf} from "prop-types";
import {Button, FormGroup, Input, Label} from "reactstrap";


class Optin extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    emptyPrivacy = {
        opt_in: false,
        opt_out: false
    }

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            privacy: this.emptyPrivacy,
            csrfToken: cookies.get('XSRF-TOKEN'),
            isLoaded: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlePrivacyChange = this.handlePrivacyChange.bind(this);
        this.handlePrivacySubmit = this.handlePrivacySubmit.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }
    handlePrivacyChange(event) {
        const target = event.target;
        const value = target.checked;
        const name = target.name;
        let privacy = {...this.state.privacy};
        privacy[name] = value;
        this.setState({privacy});
    }

    async componentDidMount() {
        const response = await fetch('/alumsum/reguser', {credentials: 'include'});
        const body = await response.text();
        if (body === '') {
            this.setState(({isAuthenticated: false}))
        } else {
            this.setState({isAuthenticated: true, user: JSON.parse(body), regEmail:JSON.parse(body).email, consent:JSON.parse(body).consent})
        }
    }

    async handlePrivacySubmit(event) {
        event.preventDefault();
        const {privacy, csrfToken} = this.state;
        await fetch('/alumsum/consent', {
            method: 'PATCH',
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(privacy),
            credentials: 'include'
        }).then((response) => {
            if(response.ok) {
                console.log(response);
            } else {
                console.log('Nope');
            }
        });
        if(privacy.opt_in) {
            this.props.history.push('/alumsum/onboarding');
        } else {
            fetch('/alumsum/logout', {method: 'POST', credentials: 'include',
                headers: {'X-XSRF-TOKEN': this.state.csrfToken}}).then(res => res.json())
                .then(response => {
                    console.log(response);
                    window.location.href = response.logoutUrl + "?id_token_hint=" +
                        response.idToken + "&post_logout_redirect_uri=" + window.location.origin;
                });
        }
    }

    render() {
        return (
            <div>
                <AppNavbar/>
                    <div className="privacyBox">
                        <div className="formContainer">
                            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                                <h1 style={{ fontSize: '24pt', fontWeight: '700' }}>1. Introduction</h1>
                                <p>
                                    Welcome to AlumSum. Your privacy is important to us, and we are committed to protecting your personal information. This notice explains how we collect, use, and share your information when you use our services. It also outlines your rights under applicable laws, including the Gramm-Leach-Bliley Act (GLBA). Further information on GLBA use of your data is available on our <a href="/alumsum/glbf">GLBA form</a>.
                                </p>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>2. Information We Collect</h2>
                                <p>
                                    We collect information that identifies, relates to, describes, or is capable of being associated with you, including:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Personal Information:</strong> When you create an account, we collect your name, email address, and other details to provide personalized financial guidance.
                                    </li>
                                    <li>
                                        <strong>Cookies and Tracking Information:</strong> We use cookies and similar technologies to track your interactions with our website. This includes referral sources, session details, and engagement with our services and offers.
                                    </li>
                                    <li>
                                        <strong>Credit Bureau Information:</strong> Through an API, we connect with a credit bureau to obtain payment and credit-related data to enhance the personalized guidance provided on your Dashboard. This data is used solely to inform your experience on AlumSum and is not shared with any other entities. It is not used to make decisions about your creditworthiness or to provide credit on differing terms.
                                    </li>
                                </ul>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>3. How We Use Your Information</h2>
                                <p>We use the information we collect to:</p>
                                <ul>
                                    <li>Provide and improve our services, including the Dashboard with personalized guidance on student loan payments.</li>
                                    <li>Track referrals and provide you with special offers from our partners, such as AlumSum-exclusive discounts on student loan refinancing.</li>
                                    <li>Enhance the accuracy and relevance of the financial guidance provided through our Dashboard by integrating credit information obtained via our API from a credit bureau.</li>
                                    <li>Suggest payment strategies that could help you save money, such as making larger payments on your student loans to reduce interest costs.</li>
                                </ul>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>4. Information Sharing</h2>
                                <p>We may share your information as follows:</p>
                                <ul>
                                    <li>
                                        <strong>For Product Features:</strong> We may use third-party API services, such as HotJar and Google, to provide you with our product. If you choose to use our product, you acknowledge and agree that you are also bound by the privacy policies and terms of use of those third parties. You may manage your HotJar API data by visiting its “Do Not Track” page here: <a href="https://www.hotjar.com/policies/do-not-track/">HotJar Do Not Track</a>. You may manage your Google API data by visiting Google’s security settings page here: <a href="https://security.google.com/settings/security/permissions">Google Security Settings</a>.
                                    </li>
                                    <li>
                                        <strong>With Third-Party Partners:</strong> We share cookie and tracking information with our refinancing partners only as necessary for the transaction, such as ensuring you enter a co-branded page when you visit their site through our links. Remember that any information you provide to third-party partners, whether through us or on your own, will be subject to their privacy practices and terms and conditions.
                                    </li>
                                    <li>
                                        <strong>For Joint Marketing:</strong> We may partner with third-party companies to jointly offer products or services to you. Information shared for these purposes may include your interactions with our site but not your personal identifiers unless necessary for the transaction. Remember that any information you provide to third-party partners, whether through us or on your own, will be subject to their privacy practices and terms and conditions.
                                    </li>
                                    <li>
                                        <strong>Credit Bureau Information:</strong> The credit-related data we obtain from credit bureaus is not shared with any other entity and is used solely in connection with your Dashboard.
                                    </li>
                                </ul>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>5. Your Choices</h2>
                                <p>You have choices about how we use and share your information:</p>
                                <ul>
                                    <li>
                                        <strong>Opt-Out Rights:</strong> You can opt-out of certain data sharing, such as sharing your information with unaffiliated third parties for marketing purposes. However, information shared through cookies for processing your transactions or joint marketing with our partners may not be subject to opt-out. Credit bureau data is not shared and therefore does not require an opt-out.
                                    </li>
                                </ul>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>6. Security</h2>
                                <p>We take the security of your personal information seriously and have implemented measures to protect it. This includes encryption and regular monitoring of our security practices.</p>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>7. Changes to This Notice</h2>
                                <p>We may update this notice from time to time. If we make significant changes, we will notify you by posting the updated notice on our website.</p>

                                <h2 style={{ fontSize: '18pt', fontWeight: '700' }}>8. Contact Us</h2>
                                <p>If you have any questions about this notice or our privacy practices, please contact us at <a href="http://alumsum.com/contact">http://alumsum.com/contact</a> or email us at <a href="mailto:support@alumsum.com">support@alumsum.com</a>.</p>

                                <p>
                                    By clicking “I Agree,” you confirm that you have read and understood this notice. You also consent to the collection, use, and sharing of your information as described in this notice and our <a href="/alumsum/glbf">GLBA form</a>. If you do not agree to these terms, you understand that you will be unable to use our services.
                                </p>
                                <form onSubmit={this.handlePrivacySubmit}>
                                        <FormGroup className="col-md-6 mb-3 dataShareForm">
                                            <Input type="checkbox" name="opt_in" id="opt_in"
                                                   onChange={(e) => this.handlePrivacyChange(e)}/>
                                            <span style={{ marginLeft: '10px' }}></span>
                                            <Label className="dataShareText">I agree</Label>
                                        </FormGroup>
                                        <FormGroup className="col-md-6 mb-3 dataShareForm">
                                            <Input type="checkbox" name="opt_out" id="opt_out"
                                                   onChange={(e) => this.handlePrivacyChange(e)}/>
                                            <span style={{ marginLeft: '10px' }}></span>
                                            <Label className="dataShareText"> I do not agree </Label>
                                        </FormGroup>
                                    <div className="row justify-content-md-center">
                                        <FormGroup>
                                            <Button type="submit" className="continuebutton">Save and Continue</Button>
                                        </FormGroup>
                                        <FormGroup>
                                            <Link color="info" tag={Link} to="/alumsum/spinwheel">Next</Link>
                                        </FormGroup>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }


}
export default withCookies(withRouter(Optin));